import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell
} from 'recharts';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import useChartContainerReady from './useChartContainerReady';

export default function StatisticsDesktopTeacherEngagementCard({
    teacherEngagementStats,
    isEditMode,
    longPressHandlers,
    theme
}) {
    const { containerRef, isReady } = useChartContainerReady();
    const primaryColor = theme?.primaryHex || '#3B82F6';

    const activeTeachers = teacherEngagementStats?.activeTeachers || [];
    const uncounseledCount = teacherEngagementStats?.uncounseledCount || 0;

    return (
        <StatisticsGlassCard className="h-full p-6 flex flex-col" {...longPressHandlers} isEditMode={isEditMode}>
            <div className="w-full mb-2">
                <StatisticsDesktopSectionHeader
                    iconSrc={STATS_ICONS.people}
                    title="교역자 활동"
                    badge={uncounseledCount > 0 ? `${uncounseledCount}명 돌봄 필요` : '양호'}
                />
            </div>

            <div ref={containerRef} className="relative w-full flex-1 min-h-[160px]">
                {isReady && activeTeachers.length > 0 ? (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={activeTeachers}
                            margin={{ top: 10, right: 10, left: -25, bottom: 0 }}
                        >
                            <defs>
                                <linearGradient id="teacherBarGrad" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor={primaryColor} stopOpacity={0.9} />
                                    <stop offset="100%" stopColor={primaryColor} stopOpacity={0.45} />
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F3F4F6" />
                            <XAxis
                                dataKey="name"
                                tick={{ fill: '#6B7280', fontSize: 11, fontWeight: 'bold' }}
                                axisLine={false}
                                tickLine={false}
                                dy={8}
                            />
                            <YAxis
                                tick={{ fill: '#D1D5DB', fontSize: 10 }}
                                axisLine={false}
                                tickLine={false}
                                width={30}
                            />
                            <Tooltip
                                cursor={{ fill: 'rgba(0,0,0,0.03)' }}
                                contentStyle={{
                                    backgroundColor: 'rgba(255,255,255,0.98)',
                                    border: 'none',
                                    borderRadius: '16px',
                                    boxShadow: '0 12px 48px rgba(0,0,0,0.12)',
                                    padding: '10px 14px',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                }}
                                formatter={(value) => [`${value}회`, '심방 기록']}
                            />
                            <Bar dataKey="count" radius={[6, 6, 0, 0]} barSize={26} animationDuration={1200} fill="url(#teacherBarGrad)">
                                {activeTeachers.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fillOpacity={1 - index * 0.12} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">
                        <div className="text-center">
                            <div className="text-3xl mb-2">👤</div>
                            <p className="text-sm">심방 활동 데이터가 없습니다</p>
                        </div>
                    </div>
                )}
            </div>
        </StatisticsGlassCard>
    );
}
